export const MAX_SITE_PROMPT_CHARACTERS = 64_000;

export interface SitePromptSnapshot {
  prompt: string;
  defaultPrompt: string;
  isDefault: boolean;
  revision: number;
  updatedAt: string | null;
}
